import { render, staticRenderFns } from "./selectPriority.vue?vue&type=template&id=bf0cd29e&scoped=true"
import script from "./selectPriority.vue?vue&type=script&lang=js"
export * from "./selectPriority.vue?vue&type=script&lang=js"
import style0 from "./selectPriority.vue?vue&type=style&index=0&id=bf0cd29e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0cd29e",
  null
  
)

export default component.exports